import * as React from 'react';
import { useEffect } from 'react';

import styled from 'styled-components';

import { THEME } from '../../packages/constants';
import { StyledModal, StyledModalTitleBar, StyledModalContent, StyledButton, StyledButtonGroup } from '../modal/modal';
import type { ModalProps } from '../modal/modal';

const StyledModalConfirm = styled(StyledModal)`
    width: ${(props: ModalProps) => (props.width ? props.width : '500px')};
    height: ${(props: ModalProps) => (props.height ? props.height : 'auto')};
`;

export const ModalConfirm = React.forwardRef<HTMLDivElement, ModalProps>(
    (
        {
            children,
            buttons,
            title,
            cancelText,
            primaryText,
            handleCancelButton,
            handlePrimaryButton,
            width,
            height,
            focusOnButton,
            ...props
        },
        ref,
    ) => {
        const cancelButtonRef = React.useRef<HTMLButtonElement>(null);
        const primaryButtonRef = React.useRef<HTMLButtonElement>(null);

        useEffect(() => {
            if (focusOnButton === 'cancel' && cancelButtonRef.current) cancelButtonRef.current.focus();
            if (focusOnButton === 'primary' && primaryButtonRef.current) primaryButtonRef.current.focus();
        });

        return (
            <StyledModalConfirm ref={ref} width={width} height={height} {...props}>
                <StyledModalTitleBar>{title}</StyledModalTitleBar>
                <StyledModalContent>{children}</StyledModalContent>
                {buttons ? (
                    buttons
                ) : (
                    <StyledButtonGroup>
                        <StyledButton
                            dataId={'modal__button--confirm'}
                            onClick={handlePrimaryButton}
                            ref={primaryButtonRef}
                        >
                            {primaryText || 'Ok'}
                        </StyledButton>
                        <StyledButton
                            theme={THEME.GENERIC}
                            dataId={'modal__button--cancel'}
                            onClick={handleCancelButton}
                            ref={cancelButtonRef}
                        >
                            {cancelText || 'Cancel'}
                        </StyledButton>
                    </StyledButtonGroup>
                )}
            </StyledModalConfirm>
        );
    },
);
ModalConfirm.displayName = 'ModalConfirm';
